import "core-js/modules/web.dom-collections.iterator.js";
import IndexedItemSearchProvider from "./IndexedItemSearchProvider";
export const ItemSearchProviders = new Map([["indexed", IndexedItemSearchProvider]]);
export function registerItemSearchProvider(type, providerClass) {
  ItemSearchProviders.set(type, providerClass);
}